import * as setup from '@/setup';
import * as audio from '@/utils/audio';

export default class Button extends Phaser.GameObjects.Container {
	/**
   *  My custom dynamic counter.
   *
   *  @constructor
   *  @class Counter
   *  @extends Phaser.GameObjects.Container
   *  @param {Phaser.Scene} scene - The scene that owns this bitmap text.
   *  @param {number} x - The horizontal coordinate relative to the scene viewport.
   *  @param {number} y - The vertical coordinate relative to the scene viewport.
   *  @param {string} icon - image key.
   *  @param {string} label - The label of the text.
   * 
   */
	constructor(scene, x, y, icon, scaleX, label, debug = false) {
		super(scene, x, y);
		// aggiungo sfondo del bottone
		var ball = scene.add.image(0, 0, 'gray-button').setScale(scaleX, 0.8);
		//selezione il colore
		if (icon === 'green-button') ball.setTint(setup.colors.green);
		else if (icon === 'red-button') ball.setTint(setup.colors.red);
		else if (icon === 'blue-button') ball.setTint(setup.colors.blue);
		else if (icon === 'yellow-button') ball.setTint(setup.colors.yellow);
		else if (icon === 'orange-button') ball.setTint(setup.colors.orange);
		// aggiungo il testo
		var text = scene.add.text(0, 0 - 5, label, setup.styles.counterStyle).setOrigin(0.5);
		text.setShadow(1, 1, '#000000', 2, true, true);
		//aggiungo al container
		this.add(ball);
		this.add(text);
		this.debug = debug;

		// Usa coordinate locali al container per l'hitArea (centrata su 0,0)
		// Questo evita problemi con il resize perché Phaser gestisce la conversione
		var halfWidth = ball.displayWidth / 2;
		var halfHeight = ball.displayHeight / 2;
		this.setInteractive(
			new Phaser.Geom.Rectangle(-halfWidth, -halfHeight, ball.displayWidth, ball.displayHeight),
			Phaser.Geom.Rectangle.Contains
		);

		// Aggiungi suono al click
		this.on('pointerup', function() {
			audio.playSound(scene, 'button-click');
		});

		// evidenzio il contorno in debug
		if (this.debug) {
			var graphics = scene.add.graphics();
			graphics.lineStyle(2, 0x00ff00, 1);
			graphics.fillStyle(0x00ff00);
			graphics.fillRect(
				this.input.hitArea.x,
				this.input.hitArea.y,
				this.input.hitArea.width,
				this.input.hitArea.height
			);
		}
		scene.children.add(this, x, y);
	}

	setTint(newTint, newTextTint) {
		this.list[0].setTint(newTint);
		this.list[1].setTint(newTextTint);
	}

	setText(newText) {
		this.list[1].setText(newText);
	}

	isContained(rect, x, y, self) {
		if (self.debug) {
			console.log('rect', rect);
			console.log('x', x + self.x);
			console.log('y', y + self.y);
			console.log('this', self);
		}
		if (Phaser.Geom.Rectangle.Contains(rect, x + self.x, y + self.y)) {
			if (self.debug) {
				console.log('si');
			}
			return true;
		} else {
			if (self.debug) {
				console.log('no');
			}
			return false;
		}
	}
	update(label) {
		this.list[1].setText(this.pad(label, 3));
	}

	pad(string, size) {
		var s = String(string);
		while (s.length < (size || 2)) {
			s = '0' + s;
		}
		return s;
	}
}
